'use strict';

angular.module('atex.dam').directive('damCollectionThumbs', ['CollectionService', function(CollectionService) {
  return {
    restrict : 'E',
    templateUrl : 'views/dam-collecton-thumbs.html',
    replace : true,

    scope : {
      entry : "=",
      styleAs:"=",
      fullscreen:"="
    },

    link : function(scope, element, attrs) {
    	CollectionService.getCollection(scope.entry.id).then(function(collection) {
    	    CollectionService.getAllCollectionItems(collection).then(function(collectionItems) {
    	      scope.images=[];
    	      collectionItems.forEach(function(content) {
    	        if (content.isForbidden && content.dontShow) {
    	          return;
    	        }
    	        var type = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/objectType');
    	        if (content.data.aspects.contentData.data.thumbUrl) {
    	          var img = {};
    	          img.url = content.data.aspects.contentData.data.thumbUrl;
    	          img.caption=content.data.aspects.contentData.data.caption;
    	          scope.images.push(img);
    	        }
    	      });
    	    }).then(null, function(error) {
    	      console.log('Error while loading collection items!', error);
    	    });
    	  }).then(null, function(error) {
    	    console.log('Error while loading collection!', error);
    	  });
    }
    
  };
  
}]);
